import { useCallback, useEffect, useState } from "react";
import { Box, Typography, Paper, Grid, FormControl, InputLabel, Select, MenuItem, Button, Alert } from "@mui/material";
import { useAuth } from "../../../context/AuthContext";
import { useProtectedRoute } from "../../../hooks/useProtectedRoute";
import { getTenantSettings, updateTenantSettings } from "../../../services/accounting";

export default function AccountingSettingsPage() {
  useProtectedRoute();
  const { token, user } = useAuth() as any;
  const tenantId = user?.tenantId || user?.tenant?.id;
  const [method, setMethod] = useState<"WA"|"FIFO">("WA");
  const [saved, setSaved] = useState(false);

  const load = useCallback(async () => {
    if (!tenantId) return;
    try {
      const s = await getTenantSettings(token!, tenantId);
      if (s?.cogsMethod) setMethod(s.cogsMethod);
    } catch (e) { console.error(e); }
  }, [tenantId, token]);

  useEffect(() => { if (token) load(); }, [token, load]);

  const save = async () => {
    if (!tenantId) return;
    await updateTenantSettings(token!, tenantId, { cogsMethod: method });
    setSaved(true);
    setTimeout(()=>setSaved(false), 1500);
  };

  return (
    <Box p={4}>
      <Typography variant="h5" fontWeight="bold" className="mb-4">Accounting Settings</Typography>
      {saved && <Alert severity="success" className="mb-3">Saved</Alert>}
      <Paper className="p-4">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel id="cogs-label">COGS Method</InputLabel>
              <Select labelId="cogs-label" label="COGS Method" value={method} onChange={(e:any)=>setMethod(e.target.value)}>
                <MenuItem value="WA">Weighted Average</MenuItem>
                <MenuItem value="FIFO">FIFO</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} className="flex items-end">
            <Button variant="contained" onClick={save}>Save</Button>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
}
